/**
 * ContributorReview Component
 * Master-detail layout for contributor management
 */

import React, { useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ContributorList } from './ContributorList';
import { ContributorDetail } from './ContributorDetail';

export const ContributorReview = () => {
  const [selectedContributor, setSelectedContributor] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [pendingApprovalFilter, setPendingApprovalFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleSelect = (contributor) => {
    setSelectedContributor(contributor);
  };

  const handleActionComplete = () => {
    // Refresh will happen automatically via React Query invalidation
  };

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex' }}>
      {/* Left Panel - Contributor List */}
      <Paper
        elevation={0}
        sx={{
          width: 400,
          borderRight: 1,
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="h6">Contributors</Typography>
        </Box>
        <ContributorList
          selectedId={selectedContributor?.id}
          onSelect={handleSelect}
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          pendingApprovalFilter={pendingApprovalFilter}
          onPendingApprovalFilterChange={setPendingApprovalFilter}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />
      </Paper>

      {/* Right Panel - Contributor Detail */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <ContributorDetail
          contributorId={selectedContributor?.id}
          onActionComplete={handleActionComplete}
        />
      </Box>
    </Box>
  );
};
